<template>
  <div data-testid="shop-cart-order-info" class="flex w-full flex-col gap-4">
    <!-- You're ordering for field -->
    <div class="flex w-full flex-col">
      <div class="mb-1 flex items-center gap-1">
        <label class="txt-body-s-bold text-main">{{ t('FestivalShop.cart.orderingFor') }}</label>
      </div>
      <div class="flex h-12 w-full items-center overflow-hidden rounded-sm border border-strong bg-surface px-3">
        <div class="flex h-10 w-[30px] items-center justify-center">
          <MdiSvg :path="mdiStore" :size="16" class="text-main" />
        </div>
        <div class="flex flex-1 items-center overflow-hidden px-2">
          <span data-testid="shop-cart-kiosk" class="truncate txt-body-m text-main">{{ kioskName }}</span>
        </div>
      </div>
    </div>

    <!-- Order type selection -->
    <!-- <div class="flex w-full flex-col gap-0.5">
      <p class="txt-body-s-bold text-main">{{ t('FestivalShop.cart.orderTypeQuestion') }}</p>
      <div class="flex w-full gap-2">
        <button
          type="button"
          :class="[
            'flex flex-1 cursor-pointer items-start gap-2 rounded border border-solid p-3 transition-all',
            orderType === 'new' ? 'border-selected bg-surface' : 'border-main hover:border-strong bg-surface',
          ]"
          @click="selectOrderType('new')"
        >
          <div
            :class="[
              'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-solid',
              orderType === 'new' ? 'border-primary-solid bg-primary-main' : 'border-strong bg-surface',
            ]"
          >
            <div v-if="orderType === 'new'" class="h-2 w-2 rounded-full bg-surface" />
          </div>
          <div class="flex min-w-0 flex-1 flex-col items-start justify-center">
            <span :class="['txt-body-s', orderType === 'new' ? 'text-primary' : 'text-main']">
              {{ t('FestivalShop.cart.placeAsNewOrder') }}
            </span>
          </div>
        </button>

        <button
          type="button"
          :class="[
            'flex flex-1 cursor-pointer items-start gap-2 rounded border border-solid p-3 transition-all',
            orderType === 'existing' ? 'border-selected bg-surface' : 'border-main hover:border-strong bg-surface',
          ]"
          @click="selectOrderType('existing')"
        >
          <div
            :class="[
              'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-solid',
              orderType === 'existing' ? 'border-primary-solid bg-primary-main' : 'border-strong bg-surface',
            ]"
          >
            <div v-if="orderType === 'existing'" class="h-2 w-2 rounded-full bg-surface" />
          </div>
          <div class="flex min-w-0 flex-1 flex-col items-start justify-center">
            <span :class="['txt-body-s', orderType === 'existing' ? 'text-primary' : 'text-main']">
              {{ t('FestivalShop.cart.addToExistingOrder') }}
            </span>
          </div>
        </button>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { mdiStore } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

export interface Props {
  kioskName?: string
  orderType?: 'new' | 'existing'
}

withDefaults(defineProps<Props>(), {
  kioskName: '',
  orderType: 'new',
})

// const emit = defineEmits<{
// 'update:orderType': [value: 'new' | 'existing']
// }>()

// function selectOrderType(type: 'new' | 'existing') {
// emit('update:orderType', type)
// }
</script>
